import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import SpriteComponent from '../../../Component/Render/Sprite';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { ShuffleTargetData } from './ShuffleCardAnimation';

export default function TornadoCardAnimation(system: CardSystem, taskData: ICardStateTaskData): void {
    const sourceCard = system.getCardByID(taskData.cards[0]);
    sourceCard.getComponent(Renderable).visible = true;
    sourceCard.score = taskData.cardsScore[0];

    const tornadoAnimator = GameObject.Instantiate(Animator);
    tornadoAnimator.addChild(sourceCard);
    system.animator.addChild(tornadoAnimator);

    const targets: ShuffleTargetData[] = taskData.targets.map((target: any, index: number) => {
        const card: BaseCard = system.getCardByID(target.cardID);
        card.score = taskData.cardsScore[index + 1];
        card.getChildByName(BaseCard.CARD_FRONT_NAME).getComponent(SpriteComponent).texture = `card${target.oldValue +
            1}`;
        return {
            ...target,
            card: card,
        };
    });

    const nonTargetCardsInPlay = system
        .getCardsInPlay()
        .filter(
            (card: BaseCard) =>
                !taskData.targets.some((targetCardData: ShuffleTargetData) => targetCardData.cardID === card.id)
        );
    system.taskQueue.queueNext(
        new CardAnimationTask(taskData, system, 'CardTornado', tornadoAnimator, {
            sourceCard: sourceCard,
            targets: targets,
            scene: system.scene,
            system,
            nonTargetCardsInPlay,
        })
    );
}
